export type YesNoDialogParams = {
  title: string;
  question: string;
  negativeResponseLabel?: string;
  affirmativeResponseLabel?: string;
  cancelResponseLabel?: string;
  showNegativeButton?: boolean;
  showAffirmativeButton?: boolean;
  showCancelButton?: boolean;
};

export type SingleInputDialogParams = {
  title?: string;
  inputLabel?: string;
  affirmativeResponseLabel?: string;
  cancelResponseLabel?: string;
  showCancelButton?: boolean;
  inputPattern?: string;
  inputMaxLength?: number;
  inputPlaceholder?: string;
};
